export default `
	guid
	updated_at
	name
	response_employee
	confidant
    photo_url
    email
    phonenumber
    landline_phonenumber
    license_plate
    access_card_id
    active
    show_calendar
	show_phonenumber
	show_favourite
	show_landline_phonenumber
	vacation_mode_active
	visible_for_employees
	can_scan_presence_qr_code
	kind
`;
